import {createStore} from "vuex";
import store from "./app/store";
export default createStore({
    modules: {
        store
    },
})
